import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import InputGroup from 'react-bootstrap/InputGroup';
import Spreadsheet, { createEmptyMatrix } from "react-spreadsheet";
import '../css/paste.css';

import {addPartsFunction} from './PartsFunction';
import {addCmListFunction} from './CmListFunction';
import ExcelCsv from "./ExcelCsv";



export default class Paste extends Component{
  
  constructor(){
    super();

    let default_tabel_data = [[{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]];
    let i =0;
    while(i<20){
      default_tabel_data.push([{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]);
      i++;
    };

    let syukka_check_abe_tabel_data = [[{ value: "JANコード" }, { value: "品名"}, { value: "数量"}, { value: "備考"}, { value: "引き当数量"}, { value: "掛率"}]];
    let a =0;
    while(a<50){
      syukka_check_abe_tabel_data.push([{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]);
      a++;
    };


    let syukka_check_maruku_tabel_data = [[{ value: "メーカー" }, { value: "品番"}, { value: "品名"}, { value: "JANID"}, { value: "発注数量"}, { value: "出庫数"}, {value:"注残数"}]];
    let m =0;
    while(m<50){
      syukka_check_maruku_tabel_data .push([{ value: "" }, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}, { value: ""}]);
      m++;
    };


    //let syukka_check_etoile_tabel_data = [[{ value: "品番" }, { value: "商品名称"}, { value: "要求数"}, { value: "処理時"}, { value: "処理時"}, { value: "今回"}, {value:"処理時"}, { value: "処理時"}, { value: "納期"} ]];
    let syukka_check_etoile_tabel_data = [[{ value: "品番" }, { value: "商品名称"}, { value: "今回不足数"}, { value: "納期"} ]];
    let e =0;
    while(e<80){
      syukka_check_etoile_tabel_data .push([{ value: "" }, { value: ""}, { value: ""}, { value: ""}]);
      e++;
    };

    let syukka_check_kaientai_tabel_data = [[{ value: "注文番号" }, { value: "注文日"}, { value: "処理状態"}, { value: "お客様オーダー番号"} , { value: "ご注文者"} , { value: "配送先"} , { value: "担当者"} , { value: "郵便番号"} , { value: "配送先住所"} , { value: "TEL"} , { value: "希望着日"} , { value: "差出名義人"} , { value: "備考"} , { value: "行"} , { value: "WEBCD"} , { value: "商品名"} , { value: "規格"} , { value: "数量"} , { value: "単価"} , { value: "金額"} , { value: "課税区分"} , { value: "お客様用メモ"} , { value: "連絡事項"} , { value: "運送便名1"} , { value: "運送便伝票NO1"} , { value: "発送日1"} , { value: "出荷場所1"} , { value: "運送便名2"} , { value: "運送便伝票NO2"} , { value: "発送日2"} , { value: "出荷場所2"} , { value: "運送便名3"} , { value: "運送便伝票NO3"} , { value: "発送日3"}, { value: "出荷場所3"} ]];
    let _k = 0;
    let _child_array = [];
    while(_k<35){
      _child_array.push({ value: ""});
      _k++;
    }
    
    let k =0;
    while(k<30){
      syukka_check_kaientai_tabel_data.push(_child_array);
      k++;
    };



    this.state={
      isOpen: false,
      table_data_default: default_tabel_data,
      table_data_syukka_abe: syukka_check_abe_tabel_data,
      table_data_syukka_maruku: syukka_check_maruku_tabel_data,
      table_data_syukka_etoile: syukka_check_etoile_tabel_data,
      table_data_syukka_etoile_default: syukka_check_etoile_tabel_data,
      table_data_syukka_kaientai:syukka_check_kaientai_tabel_data,
      select_array:['出荷確認：阿部玩具さん貼り付け',
        '出荷確認：マルクさん貼り付け',
        '出荷確認：エトワールさんメール返事分の貼り付け',
        '出荷確認：介援隊さん貼り付け'
      ],
      select_label:'',
      sheet_submit:false,
      etoile_check:false,
      re_table_data_array:[],
      isit_submit:false,
      date_label:'',
      etoile_reorder:false
    }
  }

  
  componentDidMount () {
  }
  
  openModal = () => {
    if(this.props.data.table_tonya_label==='all'){
      alert('先に対象問屋さんNo.をクリック願います.');
    }else{
      this.setState({ isOpen: true });
    }

  }

  closeModal = () => {
    this.setState({ isOpen: false }); 
    this.setState({select_label:''});
  }
  


  onClickDwonloadButton(args){
		console.dir(args);
  }
  

  
    
  render(){

    var handleChangeSelect = async (e) => {
      console.dir(e.target);

      let tonya_name_f = '';
      if (e.target.value.indexOf('マルク') !== -1) {
        tonya_name_f = 'マルク.xlsx';
        if(this.props.data.table_tonya_label!=='マルク.xlsx'){
          alert('現在マルクさん以外を選択しています、一度閉じて、マルクさんNo.をクリックしてお願いします。');
          throw new Error("Terminating script execution.");
        }
      }else if(e.target.value.indexOf('阿部玩具') !== -1){
        tonya_name_f = '阿部玩具.xlsx';
        if(this.props.data.table_tonya_label!=='阿部玩具.xlsx'){
          alert('現在阿部玩具さん以外を選択しています、一度閉じて、阿部玩具さんNo.をクリックしてお願いします。');
          throw new Error("Terminating script execution.");
        }
      }else if(e.target.value.indexOf('エトワール') !== -1){
        tonya_name_f = 'エトワール海渡.csv';
        if(this.props.data.table_tonya_label!=='エトワール海渡.csv'){
          alert('現在エトワールさん以外を選択しています、一度閉じて、エトワールさんNo.をクリックしてお願いします。');
          throw new Error("Terminating script execution.");
        }
      }else if(e.target.value.indexOf('介援隊') !== -1){
        tonya_name_f = '介援隊.csv';
        if(this.props.data.table_tonya_label!=='介援隊.csv'){
          alert('現在介援隊さん以外を選択しています、一度閉じて、介援隊さんNo.をクリックしてお願いします。');
          throw new Error("Terminating script execution.");
        }
      }else{
        tonya_name_f = 'all';
      }

      this.setState({select_label:e.target.value})
      this.setState({isit_submit:false});
      this.setState({etoile_check:false});

      //this.props.changeTonyaLabel_2(tonya_name_f); //表の変更イベントは CmList.js 内
      this.setState({date_label:''});
      this.setState({table_data_syukka_etoile:this.state.table_data_syukka_etoile_default});

      e.preventDefault();
    }

    // 出荷日
    var handleInputChange = async (e) => {
			console.dir(e.target);
      this.setState({date_label:e.target.value});
      e.preventDefault();
    }


    

    var handleTableInputChange = async (e) => {
      console.dir(e.target);
    }


    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    const changeStateTable = (val, which) => new Promise(resolve => {
      console.log('HI '+which);
      this.setState({etoile_check:val});
      
    });

    var soart_add_table = async (e) => {
      //本処理内でテーブル要素も変えようとするとNodeをうまく読み取れない、別処理にしないといけない、JSでクリックさせたけどだめ
      //console.dir(e.target.parentNode.parentNode.parentNode.childNodes[1].childNodes[1].childNodes[0].childNodes[1].childNodes);
      
      let tr_elems = document.getElementsByClassName('paste-table etoile-table')[0].childNodes[0].childNodes[1].childNodes; //耐構造変化がありそうなので
      //let tr_elems = await addPartsFunction.getTrElems();
      //let tr_elems = e.target.parentNode.parentNode.parentNode.childNodes[1].childNodes[1].childNodes[0].childNodes[1].childNodes;

      let re_arr = Object.keys(tr_elems).map(key => tr_elems[key]);

      console.dir(re_arr);
      //console.dir(typeof re_arr);

      tr_elems = addPartsFunction.soartTable(re_arr.slice(2), this.state.select_label, this.props.data.dataArray);
      //console.log(tr_elems.length);
      //await sleep(1000);
      //this.setState({etoile_check:true});
      //await changeState(true);
      //document.getElementById('change-state-etoile').click();
      
      let syukka_check_etoile_tabel_data = [[{ value: "品番" }, { value: "商品名称"}, { value: "JAN"}, { value: "注文数"}, { value: "不足数"}, { value: "納期"}, { value: "結果"}, { value: "次すること"} ]];
      let i =0;
      let result = '';
      let next = '';
      let judge_index = 5;
      while(i<tr_elems.length){
        console.dir(tr_elems[i]);
        if(tr_elems[i].val[judge_index].indexOf('終了') !== -1){
          result = '引き当てゼロ';
          next = '取り込みボタン押すと、引当たり数ゼロを自動で割り当てます';
        }else if(tr_elems[i].val[judge_index].indexOf('次回') !== -1){
          result = '引き当てゼロ';
          next = '取り込みボタン押すと、引当たり数ゼロを自動で割り当てます';
        }else if(tr_elems[i].val[judge_index].indexOf('予約注文') !== -1){
          result = '再発注？';
          next = 'エクセルダウンロードあれば再発注！引き当たり数要確認！';
          this.setState({etoile_reorder:true});
        }else if(tr_elems[i].val[judge_index].indexOf('入荷予定') !== -1){
          result = '再発注！';
          next = 'エクセルで再発注！引当たり数ゼロを自動で割り当てます';
          this.setState({etoile_reorder:true});
        }

        syukka_check_etoile_tabel_data .push([{ value: tr_elems[i].val[0] }, { value: tr_elems[i].val[1]}, { value: tr_elems[i].val[2]}, { value: tr_elems[i].val[3]}, { value: tr_elems[i].val[4]}, { value: tr_elems[i].val[5]}, { value: result}, { value: next}]);
        i++;
      };

      console.dir(syukka_check_etoile_tabel_data);

      this.setState({table_data_syukka_etoile:syukka_check_etoile_tabel_data});

      this.setState({etoile_check:true});
    }



    var submit_add_table = async (e) =>{
      console.log('\n取り込みボタン');
      this.setState({sheet_submit:true});
      //console.dir(e.target);
      let tr_elems = document.getElementsByClassName('paste-table')[0].childNodes[0].childNodes[1].childNodes;
      console.dir(tr_elems);
      console.dir(this.props.data.formData);

      if(this.state.select_label.indexOf('介援隊') !== -1){
        tr_elems = addPartsFunction.addJanData('介援隊', tr_elems, this.props.data.dataArray);
      }

      let _res = addPartsFunction.getDataIndex(tr_elems, this.state.select_label);
      let sheet_data_obj_array = _res[0];
      let reserve_jan_array = _res[1];

      let __data = this.props.data.dataArray;
			let __data_fix = this.props.data.cm_datas; //順番変わってる...
      console.dir(__data);
      console.dir(__data_fix);

      // なぜか __data_fix の順番変わっているので最初の順番に戻す
      let re__data_fix = [];
      for (let i = 0; i < this.props.data.dataFixIdArray.length; i++) {
        for (let ii = 0; ii < __data_fix.length; ii++) {
          if(this.props.data.dataFixIdArray[i]===__data_fix[ii].id){
            re__data_fix.push(__data_fix[ii]);
            break;
          }
        }
      }
      __data_fix = re__data_fix;



      let _jan = '';
      let _val = '';
      let hikiatari_id_array = '';
      let hikiate_zero_id_array = '';
      for (let i = 0; i < sheet_data_obj_array.length; i++) {
        let data_obj = sheet_data_obj_array[i]
        for (const [key, value] of Object.entries(data_obj)) {
          _jan = key;
          _val = value;
        }

        console.log(_jan+' '+String(_val));
        //console.dir(this.props.data);

        let _res_array = addCmListFunction.convertDataHikiate(_jan, _val, __data, __data_fix, this.props.data.dataFixIdArray, 'submit_sheet');
				__data = _res_array[0];
				__data_fix = _res_array[1];

        if(hikiatari_id_array===''){
          hikiatari_id_array = _res_array[2];
        }else{
          hikiatari_id_array = hikiatari_id_array.concat(_res_array[2]);
        }

        if(hikiate_zero_id_array===''){
          hikiate_zero_id_array =  _res_array[3];
        }else{
          hikiate_zero_id_array = hikiate_zero_id_array.concat(_res_array[3]);
        }
      }
      console.dir( __data_fix);
      console.dir(hikiate_zero_id_array);

      console.dir({...hikiatari_id_array});
      
      let hikiatari_id_array_fix_obj = {...hikiatari_id_array};
      const hikiatari_id_array_fix = Object.keys(hikiatari_id_array_fix_obj).map(key => hikiatari_id_array_fix_obj[key]);//obj-->array

      if(this.props.data.table_tonya_label==='エトワール海渡.csv'){
        for (let i = 0; i < __data.length; i++) {
          if(hikiatari_id_array.includes(__data[i].id)===false){
            hikiatari_id_array.push(__data[i].id);
          }
        }
        
      }



      let yoyaku_keppins = addPartsFunction.checkYoyakuKeppin(hikiate_zero_id_array, __data, __data_fix, this.props.data.dataFixIdArray); //
      __data = yoyaku_keppins[0];
      __data_fix = yoyaku_keppins[1];


      

      // 予約分 
      console.dir(reserve_jan_array);
      for (let i = 0; i < reserve_jan_array.length; i++) {
        let data_obj = reserve_jan_array[i]
        for (const [key, value] of Object.entries(data_obj)) {
          _jan = key;
          _val = value;
        }

        console.log(_jan+' '+String(_val));
        //console.dir(this.props.data);

        let _i = 0;
        while(_i<_val){
          let _res_array = addPartsFunction.researveItem(_jan, _val, __data, __data_fix, this.props.data.dataFixIdArray, 'submit_sheet', _i); //下からループしている, cm_item_name に 予約注文___ 足している
          __data = _res_array[0];
          __data_fix = _res_array[1];
          _i++;
        }
      }


      
      let _res_array = addCmListFunction.convertDataSyukkabi('', this.state.date_label, __data, __data_fix, this.props.data.dataFixIdArray, 'add_date');
      __data = _res_array[0];
      __data_fix = _res_array[1];

      console.dir(__data);
      console.dir( __data_fix);

			this.props.getCmDatas(__data_fix);
			this.props.getDataArray(__data);

			let re_hattyuu_howmany = 0;
			re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
			//this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース

      if(this.props.data.search_array!==undefined){
        if(this.props.data.search_array.length===0){
          this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, 'paste_excel');//hattyuu_howmanyベース
        }else{
          this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
        }
      }else{
				this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
			}
      

      this.setState({sheet_submit:false});
      this.setState({isit_submit:true});

      //let id_array = addPartsFunction.getCmDataIds(__data);
      //let _concat_id_array = this.props.data.show_syukka_data_id_arrays.concat(id_array);	
      let _concat_id_array = this.props.data.show_syukka_data_id_arrays.concat(hikiatari_id_array);	

      // formData, 
      // show_syukka_data_id_arrays
      // table_tonya_label
      // isit_hattyuu_board

      let re_array = [];
      for (let i = 0; i < this.props.data.dataArray.length; i++) {
        for (let ii = 0; ii < hikiatari_id_array.length; ii++) {
          if(this.props.data.dataArray[i].id===hikiatari_id_array[ii]){
            re_array.push(this.props.data.dataArray[i].id);
            break;
          } 
        }
      }
      console.dir(re_array);


      this.props.changeExcelSheet(re_array, _concat_id_array, this.props.data.table_tonya_label, true, hikiatari_id_array_fix , hikiate_zero_id_array);
      
      if(this.props.data.table_tonya_label==='エトワール海渡.csv'){
        let _btn_elm = document.getElementById('excel_download_38');
        _btn_elm.click();
        e.preventDefault();
      }
      
      
    }





    let sheet_content_class = '';
    let sheet_class = '';
    let button_class = '';
    let isit_disable = true;
    let loadding_icon = false;

    if(this.state.isOpen){
      sheet_content_class = 'paste-elem';
      sheet_class = 'sheet_modal';
      button_class = 'btn btn-sm btn-secondary  a-small sheet_close_button';
      
      if(this.props.data.table_tonya_label==='エトワール海渡.csv' || this.props.data.table_tonya_label==='マルク.xlsx' || this.props.data.table_tonya_label==='阿部玩具.xlsx' || this.props.data.table_tonya_label==='介援隊.csv'){
        button_class = 'btn btn-sm btn-success  a-small sheet_close_button';
      }

    }else{
      sheet_content_class = 'paste-elem_not_show';
      sheet_class = 'sheet_modal_not_show';
      button_class = 'btn btn-sm btn-secondary  a-small';

      if(this.props.data.table_tonya_label==='エトワール海渡.csv' || this.props.data.table_tonya_label==='マルク.xlsx' || this.props.data.table_tonya_label==='阿部玩具.xlsx' || this.props.data.table_tonya_label==='介援隊.csv'){
        button_class = 'btn btn-sm btn-success  a-small';
      }

    }



    if(this.state.select_label!==''){
      isit_disable = false;
    }else{
      isit_disable = true;
    }

    if(this.state.sheet_submit){
      loadding_icon = true;
    }

    let excel_style = 'paste-table';

    let table_data = '';
    if(this.state.select_label==='出荷確認：阿部玩具さん貼り付け'){
      table_data = this.state.table_data_syukka_abe;
    }else if(this.state.select_label==='出荷確認：マルクさん貼り付け'){
      table_data = this.state.table_data_syukka_maruku;
    }else if(this.state.select_label==='出荷確認：エトワールさんメール返事分の貼り付け' && this.state.etoile_check===false){
      table_data = this.state.table_data_syukka_etoile;
      excel_style = 'paste-table etoile-table';
    }else if(this.state.select_label==='出荷確認：エトワールさんメール返事分の貼り付け' && this.state.etoile_check===true){
      //new Promise(resolve => setTimeout(resolve, 1000));
      //table_data = this.state.re_table_data_array;
      table_data = this.state.table_data_syukka_etoile;
      excel_style = 'paste-table etoile-table';
    }else if(this.state.select_label==='出荷確認：介援隊さん貼り付け'){
      table_data = this.state.table_data_syukka_kaientai;
    }else{
      table_data = this.state.table_data_default;
    }


    return (


        
      <div className={sheet_content_class}>
          {this.props.data.isit_hattyuu_board===false ? <></> : <>
            <div className={button_class} >
              {this.state.isOpen ? <div onClick={this.closeModal}>閉じる</div> : <div onClick={this.openModal}>データを貼り付ける</div>}
            </div>
          </>}
          
        <div className={sheet_class}>
          <div className="choose_sheet_layout my-2 d-flex flex-row">
            <select className="custom-select text-center" value={this.state.select_label} onChange={handleChangeSelect}>
							{this.state.select_array.map((menu, index)=>{
          			return(
									<option key={"s_"+String(index)} value={menu}>{menu}</option>
								)
							})}
								<option defaultValue="" value="">選択ください</option>
          	</select> 

            {isit_disable ? 
              <>
                <button className="btn btn-sm btn-primary  a-small sheet_submit_button" onClick={(e)=>{submit_add_table(e)}} disabled>取り込む</button>
              </> 
              : 
              <>
                <div className="mx-2 d-flex flex-row align-items-center">
                  <label htmlFor="from-3 " className="nowrap">出荷日</label>
                  {/*<InputGroup size="sm" className="border border-warning" >
              		  <Form.Control */}
                    <input
											type="date"
                      className="form-control form-control-sm  border border-warning"
                      size="sm"
											name="from_3"
											placeholder=""
											aria-describedby="from_3"
                      //if="from-3"
											//id={"tonya_syukka_date_"+String(row.id)}
											value={this.state.date_label}
											onChange={event=>handleInputChange(event)}
										/>
                  {/*
              		</InputGroup>*/}
                </div>


                {this.state.select_label==='出荷確認：エトワールさんメール返事分の貼り付け' ? 
                  //<>
                  //  <button className="btn btn-sm btn-secondary a-small sheet_submit_button" onClick={(e)=>{soart_add_table(e); }} >{this.state.etoile_check ? <>OK</> : <>変換する</>}</button>  
                  //</>

                  <div className="mx-2">
                    
                    {this.state.etoile_check ? <>OK<span className="popup-comment">結果列を変更可能<br/>再発注！ ---> 予約注文扱い<br/>引き当てゼロ ---> 違う問屋さん探す</span></> : 
                      <>
                        <button className="btn btn-sm btn-outline-secondary a-small sheet_submit_button" onClick={(e)=>{soart_add_table(e); }} >
                          確認する
                        </button>
                      </>}

                    {/*
                    <button id="change-state-etoile" className="btn btn-sm btn-outline-secondary a-small sheet_submit_button" onClick={(e)=>{changeStateTable(true, 'etoile');}} >クリック：２<span>(Download)</span></button>
                    */}

                    {this.state.isit_submit!==true ? 
                      <>
                        {this.state.etoile_check ? 
                          <>
                            <button className="btn btn-sm btn-primary  a-small sheet_submit_button mx-2" onClick={(e)=>{submit_add_table(e)}} >
                                {this.state.etoile_reorder ? <>取り込む(Download)</> : <>取り込む</>}
                            </button>
                          </> 
                          : 
                          <>
                            <button className="btn btn-sm btn-primary  a-small sheet_submit_button mx-2" onClick={(e)=>{submit_add_table(e)}} disabled>
                                {this.state.etoile_reorder ? <>取り込む(Download)</> : <>取り込む</>}
                            </button>
                          </>
                        }
                        

                        
                        <div className="d-none">
                          <ExcelCsv
                            downloadButton={this.onClickDwonloadButton.bind(this)} 
                            data={this.props.data} 
                            tonya_id= {38} // エトワール
                            tonya_name_f= {this.props.data.table_tonya_label}
                            format = {'xlsx'}
                            style_class={'download-button-show'}
                            what_type={'researve'}
                          />
                        </div>
                      </>

                    : 
                      <div className="d-inline mx-2">取り込みOK</div>
                    }

                    <p className="d-inline small">エクセル貼り付け&出荷日 -> 確認する --> 取り込む </p>
                  </div> 


                  : 
                  <>
                    {this.state.isit_submit!==true ? 
                      <button className="btn btn-sm btn-primary  a-small sheet_submit_button" onClick={(e)=>{submit_add_table(e)}} >取り込む</button>
                    : 
                      <div className="mx-2">取り込みOK</div>
                    }
                    
                    {loadding_icon ? <>
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only"></span>
                      </div>
                    </> : <></>}
                  </>}
              </>}
            
          </div>

          <Spreadsheet 
            data={table_data} 
            className={excel_style}
          />

        </div>
        
        
      </div>
    );
  }
}
  
  

	//{...this.props}